
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"26","height":"26","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"#F26522","cx":"13","cy":"13","r":"13"}}),_c('g',{attrs:{"stroke":"#FFF","stroke-linecap":"square","stroke-width":"1.6"}},[_c('path',{attrs:{"d":"M18.577 8.236L8.22 18.593M8.236 8.236l10.357 10.357"}})])])])
      }
    
      }
    